export default "__VITE_ASSET__ZaXHLIr9__"